const CURRENCY: Record<string, string> = {
  GBP: '£',
  EUR: '€',
  USD: '$'
};

export default CURRENCY;
